import { render } from "./index.vue?vue&type=template&id=3f903c4f&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./mobileCustomerCenter.scss?vue&type=style&index=0&lang=scss"
import "./index.vue?vue&type=style&index=1&id=3f903c4f&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f903c4f"]])

export default __exports__